import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import About from "../components/About";
import Courses from "../components/Courses";
import CTASection from "../components/CTASection";

export default function HomePage() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-deep-black">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Courses />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
